
import * as React from 'react';
import { colors } from '../colors/color';
import { RadialChart } from './RadialChart';

type RadialPctChartProps = {
    pct:number,
    dim?:string,
    fontSize?:string,
    color?:string,
    maxWidth?:string,
    hidePct?:boolean,
}
export function RadialPctChart(props:RadialPctChartProps):JSX.Element
{
    const safePct = isNaN(props.pct) ? 0 : Math.max(0, Math.min(100, props.pct));
    const safeText = safePct.toFixed(0) + "%";
    const color = colors.graphs.survey.getGoodScorePctColor(safePct);

    return (
        <RadialChart 
            value={props.hidePct ? "" : safeText} 
            fillPct={safePct}
            color={props.color || color}
            dim={props.dim}
            fontSize={props.fontSize} 
            maxWidth={props.maxWidth} />
    );
}